const mapQueryKeys: Record<string, string> = {
  pageNumber: 'page.number',
  pageSize: 'page.size',
  pageSortDirection: 'page.sortDirection',
  pageSortBy: 'page.sortBy',
  pageCursor: 'page.cursor',
  pageForward: 'page.forward',
};

export class BaseApi {
  queryToSearchParams<T extends object>(query?: T): URLSearchParams {
    const searchParams = new URLSearchParams();

    for (const [k, v] of Object.entries(query || {})) {
      const fieldName = mapQueryKeys[k] === undefined ? k : mapQueryKeys[k];

      if (v !== undefined) {
        if (Array.isArray(v)) {
          for (const i of v) {
            searchParams.append(`${fieldName}[]`, String(i));
          }
        } else {
          searchParams.append(fieldName, v === null ? 'null' : v as unknown as string);
        }
      }
    }

    return searchParams;
  }

  queryToQueryString<T>(query?: T): string {
    return this.queryToSearchParams(query || {}).toString();
  }
}
